/* poor'man enum : reduce code size + a bit faster since inlined */
/**
 * package: haxe.xml
 * class: Parser
 * root Object
 * @constructor
 */
haxe.xml.Parser = function() {};
$hxClasses['haxe.xml.Parser'] = haxe.xml.Parser;
/** @private @type {Array} */
haxe.xml.Parser.__name__ = ["haxe","xml","Parser"];

/**
 * parse
 *
 * $type TFun([{ name => str, t => TInst(String,[]), opt => false }],TInst(Xml,[]))
 * static public function parse(str:String)
 * @public
 * @static
 * @param {string}  str 
 * @return {Xml}
 */
haxe.xml.Parser.parse = function(str) {
	/** @type {Xml} */ 
	var doc = Xml.createDocument();
	haxe.xml.Parser.doParse(str,0,doc);
	return doc;
};


/**
 * doParse
 *
 * $type TFun([{ name => str, t => TInst(String,[]), opt => false },{ name => p, t => TInst(Int,[]), opt => true },{ name => parent, t => TInst(Xml,[]), opt => true }],TInst(Int,[]))
 * static function doParse(str:String, p:Int = 0, ?parent:Xml):Int
 * @private
 * @static
 * @param {string}  str 
 * @param {number}  p 
 * @param {Xml}  parent 
 * @return {number}
 */
haxe.xml.Parser.doParse = function(str,p,parent) {
	if(p == null) p = 0;
	/** @type {Xml} */
	var xml = null;
	/** @type {number} */ 
	var state = 1;
	/** @type {number} */ 
	var next = 1;
	/** @type {string} */ 
	var aname = null;
	/** @type {number} */ 
	var start = 0;
	/** @type {number} */ 
	var nsubs = 0;
	/** @type {number} */ 
	var nbrackets = 0;
	/** @type {number} */ 
	var c = str.charCodeAt(p);
	/** @type {Xml} */
	var child;

	while(!(c != c)) {
		switch(state) {
			case 0:
				switch(c) {
					case 10:case 13:case 9:case 32:
						break;
					default:
						state = next;
						continue;
				}
				break;
			case 1:
				switch(c) {
					case 60:
						state = 0;
						next = 2;
						break;
					default:
						start = p;
						state = 13;
						continue;
				}
				break;
			case 13:
				if(c == 60) {
					child = Xml.createPCData(HxOverrides.substr(str,start,p - start));
					parent.addChild(child);
					nsubs++;
					state = 0;
					next = 2;
				}
				break;
			case 17:
				if(c == 93 && str.charCodeAt(p + 1) == 93 && str.charCodeAt(p + 2) == 62) {
					child = Xml.createCData(HxOverrides.substr(str,start,p - start));
					parent.addChild(child);
					nsubs++;
					p += 2;
					state = 1;
				}
				break;
			case 2:
				switch(c) {
					case 33:
						if(str.charCodeAt(p + 1) == 91) {
							p += 2;
							if(HxOverrides.substr(str,p,6).toUpperCase() != "CDATA[") throw "Expected <![CDATA[";
							p += 5;
							state = 17;
							start = p + 1;
						} else if(str.charCodeAt(p + 1) == 68 || str.charCodeAt(p + 1) == 100) {
							if(HxOverrides.substr(str,p + 2,6).toUpperCase() != "OCTYPE") throw "Expected <!DOCTYPE";
							p += 8;
							state = 16;
							start = p + 1;
						} else if(str.charCodeAt(p + 1) != 45 || str.charCodeAt(p + 2) != 45) throw "Expected <!--"; else {
							p += 2;
							state = 15;
							start = p + 1;
						}
						break;
					case 63:
						state = 14;
						start = p;
						break;
					case 47:
						if(parent == null) throw "Expected node name";
						start = p + 1;
						state = 0;
						next = 10;
						break;
					default:
						state = 3;
						start = p;
						continue;
				}
				break;
			case 3:
				if(!(c >= 97 && c <= 122 || c >= 65 && c <= 90 || c >= 48 && c <= 57 || c == 58 || c == 46 || c == 95 || c == 45)) {
					if(p == start) throw "Expected node name";
					xml = Xml.createElement(HxOverrides.substr(str,start,p - start));
					parent.addChild(xml);
					state = 0;
					next = 4;
					continue;
				}
				break;
			case 4:
				switch(c) {
					case 47:
						state = 11;
						nsubs++;
						break;
					case 62:
						state = 9;
						nsubs++;
						break;
					default:
						state = 5;
						start = p;
						continue;
				}
				break;
			case 5:
				if(!(c >= 97 && c <= 122 || c >= 65 && c <= 90 || c >= 48 && c <= 57 || c == 58 || c == 46 || c == 95 || c == 45)) {
					/** @type {string} */ 
					var tmp;
					if(start == p) throw "Expected attribute name";
					tmp = HxOverrides.substr(str,start,p - start);
					aname = tmp;
					if(xml.exists(aname)) throw "Duplicate attribute";
					state = 0;
					next = 6;
					continue;
				}
				break;
			case 6:
				switch(c) {
					case 61:
						state = 0;
						next = 7;
						break;
					default:
						throw "Expected =";
				}
				break;
			case 7:
				switch(c) {
					case 34:case 39:
						state = 8;
						start = p;
						break;
					default:
						throw "Expected \"";
				}
				break;
			case 8:
				if(c == str.charCodeAt(start)) {
					/** @type {string} */ 
					var val = HxOverrides.substr(str,start + 1,p - start - 1);
					xml.set(aname,val);
					state = 0;
					next = 4;
				}
				break;
			case 9:
				p = haxe.xml.Parser.doParse(str,p,xml);
				start = p;
				state = 1;
				break;
			case 11:
				switch(c) {
					case 62:
						state = 1;
						break;
					default:
						throw "Expected >";
				}
				break;
			case 12:
				switch(c) {
					case 62:
						if(nsubs == 0) parent.addChild(Xml.createPCData(""));
						return p;
					default:
						throw "Expected >";
				}
				break;
			case 10:
				if(!(c >= 97 && c <= 122 || c >= 65 && c <= 90 || c >= 48 && c <= 57 || c == 58 || c == 46 || c == 95 || c == 45)) {
					if(start == p) throw "Expected node name";

					/** @type {string} */ 
					var v = HxOverrides.substr(str,start,p - start);
					if(v != parent.getNodeName()) throw "Expected </" + parent.getNodeName() + ">";
					
					state = 0;
					next = 12;
					continue;
				}
				break;
			case 15:
				if(c == 45 && str.charCodeAt(p + 1) == 45 && str.charCodeAt(p + 2) == 62) {
					parent.addChild(Xml.createComment(HxOverrides.substr(str,start,p - start)));
					p += 2;
					state = 1;
				}
				break;
			case 16:
				if(c == 91) nbrackets++; else if(c == 93) nbrackets--; else if(c == 62 && nbrackets == 0) {
					parent.addChild(Xml.createDocType(HxOverrides.substr(str,start,p - start)));
					state = 1;
				}
				break;
			case 14:
				if(c == 63 && str.charCodeAt(p + 1) == 62) {
					p++;
					/** @type {string} */ 
					var str1 = HxOverrides.substr(str,start + 1,p - start - 2);
					parent.addChild(Xml.createProlog(str1));
					state = 1;
				}
				break;
		}
		c = str.charCodeAt(++p);
	}
	
	if(state == 1) {
		start = p;
		state = 13;
	}
	
	if(state == 13) {
		if(p != start || nsubs == 0) parent.addChild(Xml.createPCData(HxOverrides.substr(str,start,p - start)));
		return p;
	}
	
	throw "Unexpected end";
};


/**
 * isValidChar
 *
 * $type TFun([{ name => c, t => TInst(Int,[]), opt => false }],TEnum(Bool,[]))
 * static inline function isValidChar(c)
 * @private
 * @static
 * @param {number}  c 
 * @return {boolean}
 */
haxe.xml.Parser.isValidChar = function(c) {
	return c >= 97 && c <= 122 || c >= 65 && c <= 90 || c >= 48 && c <= 57 || c == 58 || c == 46 || c == 95 || c == 45;
};

/** @type {haxe.xml.Parser} */
haxe.xml.Parser.prototype.__class__ = haxe.xml.Parser;
